/** Public product branding. */
export const BRAND = {
    name: 'Injury Time',
    logo: '90+',
    tagline: 'Every answer matters.',
    /** URL / product slug. */
    slug: 'injurytime',
    version: '0.1.0',
};
//# sourceMappingURL=brand.js.map